import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import blogData from './blogData';
import './BlogPost.css';

const BlogPost = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const blog = blogData[slug];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!blog) {
    return (
      <>
        <section className="main-hero demo-hero">
          <div className="hero-gif-fade-left"></div>
          <div className="hero-gif-fade-right"></div>
          <h1 className="hero-page-title">Not Found</h1>
        </section>
        <section className="bp-content">
          <div className="bp-layout">
            <p className="bp-not-found">This article could not be found.</p>
            <span className="bp-back-link" onClick={() => { navigate('/resources'); window.scrollTo(0, 0); }}>
              ← Back to Resources
            </span>
          </div>
        </section>
      </>
    );
  }

  return (
    <>
      <section className="main-hero demo-hero">
        <div className="hero-gif-fade-left"></div>
        <div className="hero-gif-fade-right"></div>
        <h1 className="hero-page-title">{blog.category}</h1>
      </section>

      <section className="bp-content">
        <div className="bp-layout">
          <div className="bp-meta-row">
            <span className="bp-tag">{blog.tag}</span>
            <span className="bp-read-time">{blog.readTime}</span>
          </div>

          <h1 className="bp-title">{blog.title}</h1>

          <div className="bp-author-row">
            <div className="bp-author-left">
              <img src={blog.img} alt="" className="bp-author-img" />
              <span className="bp-author-name">{blog.author}</span>
            </div>
            <span className="bp-date">{blog.date}</span>
          </div>

          <div className="bp-divider"></div>

          <article className="bp-article">
            {blog.sections.map((section, i) => (
              <div key={i} className="bp-section">
                <h2 className="bp-section-heading">{section.heading}</h2>
                {section.paragraphs.map((p, j) => (
                  <p key={j} className="bp-paragraph">{p}</p>
                ))}
              </div>
            ))}
          </article>

          <div className="bp-divider"></div>

          <div className="bp-cta">
            <p className="bp-cta-text">Ready to secure your AI systems?</p>
            <button className="bp-cta-btn" onClick={() => { navigate('/book-demo'); window.scrollTo(0, 0); }}>
              Get a Live Demo &rarr;
            </button>
          </div>

          <span className="bp-back-link" onClick={() => { navigate('/resources'); window.scrollTo(0, 0); }}>
            ← Back to Resources
          </span>
        </div>
      </section>
    </>
  );
};

export default BlogPost;
